import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { WorksData } from '../../Store';
import WorkCard from '../WorkCard/WorkCard';
import './work.scss'


 let postsPerPage = 4;
let arrayForHoldingPosts = [];
const Work = ({ isHome }) => {
    
    if (isHome) {
        postsPerPage = 3;
    } else {
        postsPerPage = 4;
    }
    const posts = WorksData;
    const [postsToShow, setPostsToShow] = useState([]);
    const [next, setNext] = useState(postsPerPage);

    const loopWithSlice = (start, end) => {
    const slicedPosts = posts.slice(start, end);
    arrayForHoldingPosts = [...arrayForHoldingPosts, ...slicedPosts];
    setPostsToShow(arrayForHoldingPosts);
  };

    useEffect(() => {
        arrayForHoldingPosts = [];
    loopWithSlice(0, postsPerPage);
  }, []);

  const handleShowMorePosts = () => {
    loopWithSlice(next, next + postsPerPage);
      setNext(next + postsPerPage);
      console.log(next)
  };
    return (
        <div className={isHome && 'work' || 'work-page'}>
            <div className="container">
                <div className={!isHome && 'page-heading' || 'heading'}>
                    <h3>Some Thing I've Built</h3>
               
                    {isHome && 
                    <div className="head-btn">
                        <Link role="button" to="/work" className="btn btn-primary btn-head">All Works</Link>
                    </div>
                    
                    }
                </div>
                <div className="sub-container">
                    <div className="work-cards">
                        {
                            isHome && postsToShow.slice(0, 3).map(works => <WorkCard work={works}></WorkCard>)
                        }
                        {!isHome &&
                            postsToShow.map(works => <WorkCard work={works} isHome={isHome}></WorkCard>)
                        }
                    </div>
                    {!isHome && posts.length > next && <button onClick={handleShowMorePosts} className="btn btn-secondary btn-load">Load more</button>}
                </div>
                
            </div>
        </div>
    );
};

export default Work;